<template>
  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <div v-if="displayed" class="modal-overlay" :class="{ 'fullscreen': fullscreen }" @click.self="close">
      <dialog class="modal-box animate" @click.self.prevent>
        <header :class="{ 'title': title }">
          <h4 v-if="title" class="no-margin">{{ title }}</h4>
          <slot class="title-action" name="title-action" />
        </header>
        <section class="confirm-body">
          <slot name="body" />
        </section>
        <footer class="confirm-footer">
          <slot name="footer" />
        </footer>
      </dialog>
    </div>
  </transition>
</template>
<script>

import '@/lib/icons/close';

export default {
  props: {
    displayed: {
      type: Boolean,
      default: false,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },

  methods: {
    close() {
      this.$emit('close');
    },
  },
};

</script>

<style lang="scss" scoped>


.modal-overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
  background-color: rgba($primary-300, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  animation-duration: 0.3s;
}

dialog {
  background-color: white;
  position: relative;
  overflow: auto;
  padding: 0;
  z-index: 101;
  border: none;
  border-radius: 0.5rem;
  height: auto;
  width: 20rem;
}

.confirm-body {
  padding: 1rem 1rem 0rem;
}

header.title {
  display: flex;
  justify-content: center;
  align-items: baseline;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid $pearl-300;
}

footer {
  padding: 0.5rem;
  display: flex;
  justify-content: center;

  &:empty { display: none; }
}

// -- FullScreen Settings

.fullscreen {
  @media #{$screen-width-small} {
    .modal-box {
      overflow: hidden;
      width: 100%;
      height: 100%;
      border-radius: 0;
    }

    section,
    footer {
      margin: auto;
      padding: 1rem;
      max-width: 32rem;
    }
  }

  @media #{$screen-width-medium} {
    section,
    footer {
      padding: 1rem;
      max-width: 52.25rem;
    }
  }
}

// -- Animation

.v-enter-to dialog {
  animation-name: slideInUp;
  animation-duration: 0.3s;
}

.v-leave-to dialog {
  animation-name: slideOutDown;
  animation-duration: 0.3s;
}

</style>
